import { useCallback } from 'react';

import { ChannelOrAgentDropdownSelector } from '@/components/shared/components/AgentSelectionComponent/components/ChannelOrAgentDropdownSelector';
import { useMerchantGroupMerchants } from '@/components/shared/components/AgentSelectionComponent/hooks/useMerchantGroupMerchants';
import { MerchantMap } from '@/components/shared/components/AgentSelectionComponent/maps/merchant.map';
import { AgentSelectionComponentStateSetter } from '@/components/shared/components/AgentSelectionComponent/types/AgentSelectionComponentStateSetter';
import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';
import { Text } from '@/components/shared/components/Text';
import { ICON_NAMES } from '@/config/config';
import { MerchantInStructure } from '@/types/MerchantInStructure';

export interface MerchantSelectorProps {
  selectedMerchant: MerchantInStructure | undefined;
  setState: AgentSelectionComponentStateSetter;
}

export const MerchantSelector = ({ selectedMerchant, setState }: MerchantSelectorProps) => {
  const { merchants } = useMerchantGroupMerchants();

  const resetItem = useCallback(() => !selectedMerchant, [selectedMerchant]);

  const value: SelectItem | undefined = selectedMerchant
    ? {
        id: selectedMerchant.id,
        name: selectedMerchant.businessName,
        icon: ICON_NAMES.MERCHANT,
      }
    : undefined;

  return (
    <ChannelOrAgentDropdownSelector
      title={<Text tId={'MERCHANT'} />}
      subtitle={<Text tId={'SELECT_A_MERCHANT'} />}
      resetItem={resetItem}
      icon={ICON_NAMES.MERCHANT}
      value={value}
      items={merchants?.map(MerchantMap.toSelectItem) as SelectItem[]}
      handleClickItem={(item) => {
        const merchant = merchants?.find((m) => m.id === item.id);
        if (!merchant) return;
        setState((state) => ({
          ...state,
          selectedMerchant: MerchantMap.toPartialMerchantInStructure(merchant),
          selectedChannel: undefined,
          selectedAgent: undefined,
        }));
      }}
    />
  );
};
